<template>
  <div class="laryerBody">
    <!-- <div class=""></div> -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>人员管理</span>
        <el-button style="float: right; padding: 3px 0" type="text">新增用户</el-button>
      </div>
    <div class="cordBody">
         <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="laryerName"
        label="人员名称"
        >
      </el-table-column>
      <el-table-column
        prop="联系方式"
        label="图层类型"
       >
      </el-table-column>
    
      <el-table-column
        prop="uploadUser"
        label="用户类型">
      </el-table-column>
       <el-table-column
        prop="uploadUser"
        label="是否启用">
         <template slot-scope="scope">
            <el-switch
  v-model="scope.row.isSHow"
  active-color="#13ce66"
  inactive-color="#ff4949">
</el-switch>
      </template>
      </el-table-column>
      <el-table-column
        prop="uploadUser"
        width="300"
        label="操作">
         <template slot-scope="scope">
   
       
        <el-button
          size="mini"
          type="danger"
         >删除</el-button>
      </template>
      </el-table-column>
    </el-table>
    </div>
    </el-card>
  </div>
</template>

<script>
export default {
    data(){
        return{
             tableData: [
                
             ]
        }
    }
};
</script>

<style>
.laryerBody {
  height: 100%;
  width: 100%;
  padding:15px;
  background-color: rgb(244, 244, 244);
}
.box-card{
    height:100%;
    width:100%;
}
.cordBody{
   
   
}
</style>